<template>
  <div class="createDriver-container">
    <b-form @submit="submitForm" @reset="onReset" v-if="show">
      <b-row>
        <b-col cols="8">
          <b-card no-body>
            <b-card-header>
              <b-row class="align-items-center">
                <b-col>
                  <h3>Fahrerdaten</h3>
                </b-col>
                <b-col>
                  <b-button type="submit" size="sm" variant="success" class="float-right"><i class="far fa-dot-circle"></i> Speichern</b-button>
                  <b-button type="reset" size="sm" variant="danger" class="float-right mr-1"><i class="fa fa-ban"></i> Reset</b-button>
                </b-col>
              </b-row>
            </b-card-header>
            <b-card-body>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="Vorname:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="driverForm.firstname"
                      required
                      placeholder="Vorname"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="Nachname:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="driverForm.lastname"
                      required
                      placeholder="Nachname"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="Geburtsdatum:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      type="date"
                      v-model="driverForm.dayofbirth"
                      placeholder="Nachname"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="Telefonnummer:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="driverForm.phone"
                      placeholder="01xx / xxxx xxxx xx"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="Adresszusatz:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="driverForm.address.address_line_1"
                      placeholder="c/o Hotel zur Rose"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="Adresse:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="driverForm.address.address_line_2"
                      required
                      placeholder="Str. + HNr."
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-group id="input-group-1" label="PLZ:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="driverForm.address.postcode"
                      required
                      placeholder="PLZ"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="input-group-1" label="Ort:" label-for="input-1">
                    <b-form-input
                      id="input-1"
                      v-model="driverForm.address.city"
                      required
                      placeholder="Ort"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-card-body>
          </b-card>
        </b-col>
        <!--<b-col cols="4">
          <b-card no-body>
            <b-card-header>
              <h3>Einsatzort</h3>
            </b-card-header>
            <b-card-body>
              <b-table bordered
                       fixed
                       responsive
                       style="overflow-y: auto;"
                       :items="areaTableData"
                       :fields="areaTableFields"
              >
                <template v-slot:cell(actions)="data">
                  <div class="text-center">
                    <b-button-group>
                      <b-button variant="warning" :to="'/vehicles/edit/' + data.item.id">
                        <i class="fas fa-pencil-alt"></i>
                      </b-button>
                      <b-button variant="danger" :to="'/vehicles/edit/' + data.item.id">
                        <i class="fas fa-times"></i>
                      </b-button>
                    </b-button-group>
                  </div>
                </template>
              </b-table>
            </b-card-body>
          </b-card>
        </b-col>-->
      </b-row>
    </b-form>
  </div>
</template>

<script>
    import { fetchDriver } from "@/api/driver";
    import Resource from '@/api/resource';

    const driverResource = new Resource('drivers');

    const emptyForm = {
        firstname: '',
        lastname: '',
        dayofbirth: '',
        phone: '',
        address: {
            address_line_1: '',
            address_line_2: '',
            postcode: '',
            city: '',
            country: 'Germany'
        },
    };

    export default {
        name: "DriverDetail",
        props: {
            isEdit: {
                type: Boolean,
                default: false,
            },
            isNew: {
                type: Boolean,
                default: false,
            },
        },
        components: {
        },
        data() {
            return {
                driverForm: Object.assign({}, emptyForm),
                fetchedData: null,
                loading: false,
                driverListOptions: [],
                show: true,
                areaTableFields: [
                    {
                        key: 'area',
                        label: 'Einsatzort'
                    },
                    {
                        key: 'from',
                        label: 'von'
                    },
                    {
                        key: 'to',
                        label: 'bis'
                    },
                    {
                        key: 'actions',
                        label: 'Aktionen'
                    }
                ],
                areaTableData: [
                    {area: 'Rauenheim', from: '2019-12-31', to: ''},
                ]
            };
        },
        computed: {
            lang() {
                return this.$store.getters.language;
            },
        },
        created() {
            if (this.isNew) {
                this.$swal('Erfolg', 'Neuer Fahrer wurde angelegt', 'success');
            }
            if (this.isEdit) {
                const id = this.$route.params && this.$route.params.id;
                this.fetchData(id);
            } else {
                this.driverForm = Object.assign({}, this.emptyForm);
                this.driverForm.address = Object.assign({}, emptyForm.address);
            }
        },
        methods: {
            async fetchData(id) {
                this.loading = true;
                const { data } = await fetchDriver(id);
                this.driverForm = Object.assign({}, data);
                //this.driverForm = data;
                if (this.driverForm.address === null) {
                    this.driverForm.address = Object.assign({}, emptyForm.address);
                }
                this.fetchedData = Object.assign({}, data);
                this.fetchedData.address = Object.assign({}, data.address);
                this.fetchedData.address.country = "Germany";
                this.driverForm.address.country = "Germany";
                this.loading = false;
            },
            async submitForm(event) {
                event.preventDefault();
                this.loading = true;
                if (this.isEdit) {
                    try {
                    await driverResource.update(this.fetchedData.id, this.driverForm);
                } catch (e) {
                    this.$swal('Fehler', e.message, 'error');
                    this.loading = false;
                    return;
                }
                this.$swal('Erfolg', 'Änderungen erfolgreich gespeichert', 'success');
                } else {
                    let response = await driverResource.store(this.driverForm);
                    this.loading = false;
                    console.log(response);
                    this.$router.push({ name: 'changeDriver', params: { id: response.data.id , isNew: true, isEdit: true } });
                }
                this.loading = false;
            },
            onReset(event) {
                event.preventDefault();
                // Reset our form values
                if (this.fetchedData !== null) {
                    this.driverForm = Object.assign({}, this.fetchedData);
                    this.driverForm.address = Object.assign({}, this.fetchedData.address);
                } else {
                    this.driverForm = Object.assign({}, this.emptyForm);
                    this.driverForm.address = Object.assign({}, this.emptyForm.address);
                }
                // Trick to reset/clear native browser form validation state
                this.show = false;
                this.$nextTick(() => {
                    this.show = true;
                })
            }
        },
    }
</script>

<style scoped>
  /deep/ .table > tbody > tr > td {
    vertical-align: middle !important;
  }
  /deep/ /deep/ .scrollable {
    word-break: break-all;
    white-space: nowrap;
    max-height: 100px;
    overflow-y: auto;
  }
</style>
